var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import ImageLoader from "../../loader/ImageLoader.js";
import * as PIXI from "pixi.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { M as MaskSchema } from "../../Mask-de6e3148.js";
import "../../global-33d5eebf.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../types.js";
import "../../utils/byteArray.js";
class MaskPixiSystem {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "schema", MaskSchema);
  }
  init(entity, gameModel, viewport) {
    const spriteData = gameModel.getTypedUnsafe(entity, MaskSchema);
    const pixiSystem = gameModel.getPixiSystem(spriteData.pixiComponent);
    if (!pixiSystem.instances[entity]) {
      return;
    }
    const imageTexture = ImageLoader.getInstance().getPixiTexture(spriteData.maskKey);
    const mask = PIXI.Sprite.from(imageTexture);
    pixiSystem.instances[entity].container.addChild(mask);
    if (pixiSystem.instances[entity].sprite) {
      mask.width = spriteData.width || pixiSystem.instances[entity].sprite.width;
      mask.height = spriteData.height || pixiSystem.instances[entity].sprite.height;
      pixiSystem.instances[entity].sprite.mask = mask;
      mask.anchor.set(spriteData.anchorX, spriteData.anchorY);
    } else if (pixiSystem.instances[entity].graphic) {
      pixiSystem.instances[entity].container.addChild(mask);
      mask.width = spriteData.width || pixiSystem.instances[entity].graphic.width;
      mask.height = spriteData.height || pixiSystem.instances[entity].graphic.height;
      pixiSystem.instances[entity].graphic.mask = mask;
      mask.anchor.set(spriteData.anchorX, spriteData.anchorY);
    }
    this.ids.add(entity);
  }
  run(entity, gameModel, viewport) {
    if (!this.ids.has(entity)) {
      this.init(entity, gameModel, viewport);
    }
    const maskData = gameModel.getTypedUnsafe(entity, MaskSchema);
    const pixiSystem = gameModel.getPixiSystem(maskData.pixiComponent);
    pixiSystem.instances[entity].graphic.mask.width = maskData.width || pixiSystem.instances[entity].graphic.width;
    pixiSystem.instances[entity].graphic.mask.height = maskData.height || pixiSystem.instances[entity].graphic.height;
  }
  cleanup(entity, gameModel, viewport) {
    this.ids.delete(entity);
  }
}
registerPixiComponent("Mask", MaskPixiSystem);
//# sourceMappingURL=Mask.js.map
